export default "__VITE_ASSET__BA30vNBi__"